/* FELRIO — Collection nav + unified filter/sort panel + grid view */
(function () {
  "use strict";

  var grid = document.getElementById("ProductGridContainer");

  /* ── Grid view switcher ── */
  var VIEW_KEY = "felrio-grid-view-v2";
  var viewBtn = document.querySelector("[data-cnav-view]");

  function applyView(v) {
    document.body.setAttribute("data-felrio-view", v);
    if (viewBtn) viewBtn.setAttribute("data-cnav-view", v);
    try { localStorage.setItem(VIEW_KEY, String(v)); } catch (e) {}
  }

  (function () {
    var saved;
    try { saved = parseInt(localStorage.getItem(VIEW_KEY), 10); } catch (e) {}
    applyView(saved >= 1 && saved <= 3 ? saved : 2);
  })();

  if (viewBtn) {
    viewBtn.addEventListener("click", function () {
      var cur = parseInt(viewBtn.getAttribute("data-cnav-view"), 10) || 1;
      applyView(cur >= 3 ? 1 : cur + 1);
    });
  }

  /* ── Shared AJAX helper ── */
  var busy = false;

  function pathname(url) {
    try { return new URL(url, location.href).pathname.replace(/\/$/, ""); }
    catch (e) { return url; }
  }

  function ajaxLoadGrid(url, onSuccess) {
    if (busy || !grid) return;
    busy = true;
    grid.style.opacity = "0.35";
    grid.style.pointerEvents = "none";
    grid.style.transition = "opacity 0.15s ease";

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error("fetch failed");
        return r.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var newGrid = doc.getElementById("ProductGridContainer");
        if (newGrid) grid.innerHTML = newGrid.innerHTML;
        grid.style.opacity = "";
        grid.style.pointerEvents = "";
        busy = false;
        if (typeof window.felrioReinitSliders === "function") window.felrioReinitSliders();
        if (onSuccess) onSuccess();
      })
      .catch(function () {
        busy = false;
        grid.style.opacity = "";
        grid.style.pointerEvents = "";
        window.location.href = url;
      });
  }

  /* ── Collection nav AJAX ── */
  var nav = document.querySelector("[data-ajax-nav]");

  if (nav) {
    nav.addEventListener("click", function (e) {
      var link = e.target.closest(".felrio-cnav__item");
      if (!link || busy) return;
      var newUrl = link.href;
      if (pathname(newUrl) === pathname(location.href)) return;
      e.preventDefault();

      nav.querySelectorAll(".felrio-cnav__item").forEach(function (item) {
        item.classList.remove("is-active");
      });
      link.classList.add("is-active");

      ajaxLoadGrid(newUrl, function () {
        history.pushState({ cnavUrl: newUrl }, "", newUrl);
        updateBadge(newUrl);
        /* Keep filter form scoped to the newly active collection */
        if (filterForm) {
          filterForm.setAttribute("action", newUrl);
          filterForm.reset();
        }
        if (clearBtn) clearBtn.setAttribute("href", newUrl);
      });
    });
  }

  /* ── Filter / Sort panel ── */
  var filterEl    = document.querySelector("[data-felrio-filter]");
  var filterBtn   = filterEl && filterEl.querySelector("[data-filter-trigger]");
  var filterPanel = filterEl && filterEl.querySelector("[data-filter-panel]");
  var filterForm  = filterEl && filterEl.querySelector("[data-filter-form]");
  var clearBtn    = filterEl && filterEl.querySelector("[data-filter-clear]");

  function openFilter() {
    if (!filterEl) return;
    filterEl.setAttribute("data-open", "");
    if (filterBtn) filterBtn.setAttribute("aria-expanded", "true");
    if (filterPanel) filterPanel.removeAttribute("aria-hidden");
  }

  function closeFilter() {
    if (!filterEl) return;
    filterEl.removeAttribute("data-open");
    if (filterBtn) filterBtn.setAttribute("aria-expanded", "false");
    if (filterPanel) filterPanel.setAttribute("aria-hidden", "true");
  }

  if (filterBtn) {
    filterBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      filterEl.hasAttribute("data-open") ? closeFilter() : openFilter();
    });
  }

  document.addEventListener("click", function (e) {
    if (filterEl && !filterEl.contains(e.target)) closeFilter();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeFilter();
  });

  /* Count filter params in URL for badge */
  function updateBadge(url) {
    try {
      var params = new URL(url, location.href).searchParams;
      var count = 0;
      var hasPriceFilter = false;
      params.forEach(function (val, key) {
        if (!key.startsWith("filter.") || val === "") return;
        if (key === "filter.v.price.gte" || key === "filter.v.price.lte") {
          hasPriceFilter = true;
        } else {
          count++;
        }
      });
      if (hasPriceFilter) count++;
      var badge = document.querySelector("[data-filter-badge]");
      if (badge) {
        badge.textContent = count;
        badge.style.display = count > 0 ? "" : "none";
      }
    } catch (e) {}
  }

  /* AJAX filter form submit */
  if (filterForm) {
    filterForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var base = new URL(filterForm.getAttribute("action"), location.href);
      base.search = "";
      var data = new FormData(filterForm);
      data.forEach(function (val, key) {
        if (val !== "" && val !== null) base.searchParams.append(key, val);
      });
      var newUrl = base.toString();
      closeFilter();
      ajaxLoadGrid(newUrl, function () {
        history.pushState({ filterUrl: newUrl }, "", newUrl);
        updateBadge(newUrl);
      });
    });
  }

  /* AJAX clear all */
  if (clearBtn) {
    clearBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var clearUrl = clearBtn.getAttribute("href");
      closeFilter();
      ajaxLoadGrid(clearUrl, function () {
        history.pushState({ filterUrl: clearUrl }, "", clearUrl);
        updateBadge(clearUrl);
        if (filterForm) filterForm.reset();
      });
    });
  }

  /* ── Popstate ── */
  window.addEventListener("popstate", function (e) {
    if (e.state && (e.state.cnavUrl || e.state.filterUrl || e.state.sortUrl)) {
      window.location.reload();
    }
  });

  /* ── MODEL / PRODUCT toggle ── */
  var modelBtn = document.querySelector("[data-model-btn]");
  var modelActive = false;

  function applyModelMode(active) {
    document.body.setAttribute("data-felrio-model", active ? "1" : "0");
    if (modelBtn) {
      modelBtn.textContent = active ? "PRODUCT" : "MODEL";
      modelBtn.setAttribute("aria-pressed", active ? "true" : "false");
      modelBtn.classList.toggle("is-active", active);
    }
  }

  if (modelBtn) {
    modelBtn.addEventListener("click", function () {
      modelActive = !modelActive;
      applyModelMode(modelActive);
    });
  }

  /* ── Scroll-hide sticky bar ── */
  var stickyBar = document.querySelector(".felrio-sticky-bar");
  var lastScrollY = window.scrollY;
  var scrollThreshold = 60;

  window.addEventListener("scroll", function () {
    if (!stickyBar) return;
    var currentY = window.scrollY;
    if (currentY > lastScrollY && currentY > scrollThreshold) {
      stickyBar.classList.add("felrio-bar-hidden");
    } else {
      stickyBar.classList.remove("felrio-bar-hidden");
    }
    lastScrollY = currentY;
  }, { passive: true });

})();
